import { useCallback, useEffect, useReducer, useState } from "react";
import Form from "@src/components/forms/Form";
import { Checkbox, DropDown, FormInput, Loader } from "@src/components/atoms";
import Button from "@src/components/atoms/Button";
import { charitySchema } from "../formHelpers";

export const CharityForm = ({
  isNew = false,
  data = {},
  onSubmit,
  onCancel,
}) => {
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const initialCharityObject = {
    name: data?.name || "",
    description: data?.description || "",
    donationStatement: data?.donationStatement || "",
    donationAmount: data?.donationAmount || "",
    videoId: data?.videoId || "",
    url: data?.url || "",
  };

  const handleSubmit = async (data) => {
    setSubmitting(true);
    setError(null);

    try {
      onSubmit && (await onSubmit(data));
    } catch (err) {
      setError("Failed to submit");
    } finally {
      setSubmitting(false);
    }
  };

  if (!isNew && !data?.name) {
    return <Loader />;
  }

  return (
    <div className="flex flex-col overflow-scroll">
      <Form
        onSubmit={(data) => {
          handleSubmit(data);
        }}
        schema={charitySchema}
        options={{ defaultValues: initialCharityObject }}
        className="space-y-6"
      >
        {(methods) => {
          const hasChanged = methods.formState.isDirty;
          return (
            <>
              <div className="mt-4 space-y-4 border-t pt-4">
                <FormInput
                  label="Charity Name"
                  name="name"
                  value={methods.watch("name")}
                  onChange={(e) => {
                    methods.setValue("name", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
                <FormInput
                  label="Charity Description"
                  name="description"
                  value={methods.watch("description")}
                  onChange={(e) => {
                    methods.setValue("description", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
                <FormInput
                  label="Donation Statement"
                  name="donationStatement"
                  value={methods.watch("donationStatement")}
                  onChange={(e) => {
                    methods.setValue("donationStatement", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
                <FormInput
                  label="Donation Amount"
                  type="number"
                  name="donationAmount"
                  value={methods.watch("donationAmount")}
                  onChange={(e) => {
                    methods.setValue("donationAmount", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
                <FormInput
                  label="Video ID"
                  name="videoId"
                  value={methods.watch("videoId")}
                  onChange={(e) => {
                    methods.setValue("videoId", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
                <FormInput
                  label="Charity URL"
                  name="url"
                  value={methods.watch("url")}
                  onChange={(e) => {
                    methods.setValue("url", e.target.value, {
                      shouldValidate: true,
                      shouldDirty: true,
                      shouldTouch: true,
                    });
                  }}
                />
              </div>
              <Button submit disabled={!hasChanged} loading={submitting}>
                Save changes
              </Button>
              {error && (
                <div className="mt-4 text-xs italic text-red-500">{error}</div>
              )}
            </>
          );
        }}
      </Form>{" "}
    </div>
  );
};
